import React, { useEffect } from 'react';

export default function IntegrationsSetupListItemInstructionsModal(props) {
    useEffect(() => {
        return () => {
            $('#create-integration').off('hidden.bs.modal');
        };
    }, []);

    return (
        <div
            className="modal fade"
            id="integration-setup-instruction-modal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="integration-setup-instruction-modal"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-xl" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{$t('Setup Instructions')}</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={props.closeHandler}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body" dangerouslySetInnerHTML={{ __html: props.provider?.setup_instructions || '' }}></div>
                    <div className="modal-footer">
                        <button type="button" className="button -secondary" onClick={props.closeHandler}>
                            {$t('Close')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
